import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Typography from '@material-ui/core/Typography'

export const DynamicTicketTextItem = ({label, text}) => {
  const classes = useStyles();
  return (
    <>
     <Typography className={[classes.label, "ticket-dynamic-label"].join(' ')}>
       { label }
      </Typography>
      <Typography className={[classes.text, "ticket-dynamic-text"].join(' ')}>
        { text }
      </Typography>
    </>
  )
}

const useStyles = makeStyles({
  label: {
    fontSize: '1rem',
    fontWeight: '500'
  },
  text: {
    fontSize: '0.8rem'
  }
})